var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SINGLETEXT Absolutely-Centralization"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.cont.title))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.cont.stem))]),_c('button',{on:{"click":_vm.Ook}},[_vm._v(" 我知道啦")])])
}
var staticRenderFns = []

export { render, staticRenderFns }